module.exports = __webpack_public_path__ + "img/align-center.9d604d30.svg";